module.exports = __webpack_public_path__ + "static/media/Cronograma.89b805a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Cronograma.svg
// module id = 826
// module chunks = 0